// import axios, { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import appStore from '@/store/app';

import authenticator from '@/store/authentication';

const useHttpRequestInterceptor: (apiVersion: string, requestTimeout: number) => void = (apiVersion, requestTimeout) => {

   axios.defaults.headers.common = { 'X-Version': apiVersion };
   axios.defaults.timeout = requestTimeout;

   const instance = axios.interceptors;

   instance.request.use((config) => {
      if (authenticator.isLoggedIn) {
         config.headers.Authorization = `Bearer ${authenticator.accessToken}`;
      }
      return config;
   }, (reason) => {
      return Promise.reject(reason);
   });

   instance.response.use((response) => {
      return response;
   }, (reason) => {
      if (reason.response && reason.response.data && reason.response.data.error) {
         if (reason.response.data.error.code === 'UnsupportedApiVersion') {
            appStore.error({ message: 'Version di API non supportata' });
         }
      }
      return Promise.reject(reason);
   });

};

export default useHttpRequestInterceptor;

